<script setup lang="ts">
  import { computed, defineProps } from 'vue';
  import { Info } from '@/types';

  const props = defineProps<{
    data: Info;
  }>();

  const goodDocument = computed(() => {
    return props.data?.cert?.toLowerCase()?.includes('good');
  });
</script>

<template>
  <div class="mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md">
    <div class="flex justify-between">
      <div>Document Type :</div>
      <div>
        <b
          :class="{
            'text-green-500': goodDocument,
          }"
          v-if="data?.cert"
          >{{ data?.cert }}
          <span v-if="data?.cert">For export from the USA</span>
        </b>
        <b
          v-else
          :class="{
            'text-red-500': !goodDocument,
          }"
        >
          Unknown, ask manager
        </b>
      </div>
    </div>
    <div class="text-sm text-gray-700">
      Problems with documents may cause additional expenses. For more
      information, please refer to the work chat.
    </div>
  </div>
</template>

<style scoped></style>
